import styled from "styled-components";

export const Container = styled.button`
  width: 60%;
  height: 40px;
  margin: 10px 0;
  border: none;
  border-radius: 8px;
  background-color: ${(props) => (props.autumnFern ? "#517649" : "#470b00")};
  color: var(--white);
  transition: 1.1s;
  border: 0.3px solid var(--snow-flurry);
  font-family: "PT Serif", serif;
  font-size: 1rem;
  &&:hover {
    border: 1.5px solid var(--matterhorn);
  }
`;
